module.exports = __webpack_public_path__ + "img/Event-Driven_Architecture_for_Scalable_Systems.28ee9770.jpeg";